/**
 * Centralized pricing configuration
 * Update these values when changing prices or promotions
 */
export const PRICING = {
  originalPrice: 30,
  currentPrice: 30,
  isPromoActive: false,
  promoName: "",
};
